export default function XIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7045 10.6226L20.4006 3H18.814L12.9973 9.6172L8.35479 3H2.99902L10.0209 13.0072L2.99902 21H4.58555L10.7245 14.0104L15.6282 21H20.984L13.7045 10.6226ZM11.5308 13.0951L10.8183 12.098L5.15769 4.17134H7.59492L12.1646 10.5708L12.8741 11.5679L18.8133 19.8858H16.376L11.5308 13.0951Z"
        fill="currentColor"
      />
      <path
        d="M19.5881 20H15.523L4.41192 4H8.47697L19.5881 20Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_125_2113)">
        <path
          d="M20.5 2L13.2704 10.2337M2.5 22.5L10.7174 13.1413"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_125_2113">
          <rect
            width="20"
            height="18"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function XIconSmall() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_966_4710)">
        <path
          d="M18.2962 2.59265L12.941 8.69171M4.96289 17.7778L11.0498 10.8455"
          stroke="currentColor"
          strokeWidth="1.48148"
        />
        <path
          d="M17.5366 15.8333H14.1978L6.17697 4.16665H9.43478L17.5366 15.8333Z"
          stroke="currentColor"
          strokeWidth="1.66667"
        />
      </g>
      <defs>
        <clipPath id="clip0_966_4710">
          <rect
            width="14.8148"
            height="13.3333"
            fill="currentColor"
            transform="translate(4.59277 3.33331)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
